import React, { ReactNode } from "react";
import { DialogProvider as CoreDialogProvider } from "../../DialogContext";
import { useLanguage } from "./LanguageContext";

// Komunikaty i okno potwierdzenia panelu (A24). Logika jest wspólna z konfiguratorem
// (src/DialogContext.tsx) - tu tylko etykiety przycisków w języku panelu (EN / DE).
export { useDialogs } from "../../DialogContext";
export type { ConfirmOptions, NoticeType } from "../../DialogContext";

export const DialogProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { t } = useLanguage();
  return (
    <CoreDialogProvider
      labels={{ confirmTitle: t("Please confirm"), ok: t("OK"), cancel: t("Cancel"), close: t("Close") }}
    >
      {children}
    </CoreDialogProvider>
  );
};
